module.exports = __webpack_public_path__ + "static/media/M Mall 1.f8c8f5e3.png";